module.exports = __webpack_public_path__ + "img/icon-collapse.b80f7eca.svg";